export const INIT_ALERT = 'INIT_ALERT';
export const FLUSH_ALERT = 'FLUSH_ALERT';
export const NEW_MESSAGE = 'NEW_MESSAGE';
export const SET_USER_TYPING_STATUS = 'SET_USER_TYPING_STATUS';
export const SET_MESSAGE_STATUS = 'SET_MESSAGE_STATUS';
export const CHECK_SCREEN_WIDTH = 'CHECK_SCREEN_WIDTH';
export const SOCKET_ERROR = 'SOCKET_ERROR';
export const LOADING_MESSAGE = 'LOADING_MESSAGE';
